const input =
  "mt-1 h-9 w-full rounded-sm border border-slate-300 bg-white px-2.5 text-[13px] outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-200";
const label = "label-xs mt-3 block";

const SUBSCRIPTION_STATUSES = [
  "TRIAL",
  "ACTIVE",
  "PAYMENT_DUE",
  "PAST_DUE",
  "CANCELLED",
  "MANUAL",
];

export const AccountEditFields = ({ form, set, plans, planLimits }) => (
  <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
    <div>
      <label className={label}>Bedrijfsnaam</label>
      <input
        value={form.company_name}
        onChange={set("company_name")}
        data-testid="admin-detail-company"
        className={input}
      />
    </div>
    <div>
      <label className={label}>E-mailadres (login)</label>
      <input
        type="email"
        value={form.contact_email}
        onChange={set("contact_email")}
        data-testid="admin-detail-email"
        className={input}
      />
    </div>
    <div>
      <label className={label}>Telefoon</label>
      <input value={form.phone} onChange={set("phone")} className={input} />
    </div>
    <div>
      <label className={label}>Abonnement</label>
      <select
        value={form.plan_code}
        onChange={set("plan_code")}
        data-testid="admin-detail-plan"
        className={input}
      >
        {(plans || []).map((plan) => (
          <option key={plan.code} value={plan.code}>
            {`${plan.name} — € ${plan.base_price}`}
          </option>
        ))}
      </select>
    </div>
    <div>
      <label className={label}>Abonnementstatus</label>
      <select
        value={form.subscription_status}
        onChange={set("subscription_status")}
        data-testid="admin-detail-subscription-status"
        className={input}
      >
        {SUBSCRIPTION_STATUSES.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>
    </div>
    <div>
      <label className={label}>Maandprijs (leeg = standaard)</label>
      <input
        type="number"
        step="0.01"
        min="0"
        value={form.monthly_price}
        onChange={set("monthly_price")}
        data-testid="admin-detail-price"
        className={input}
      />
    </div>
    <div>
      <label className={label}>Trial tot</label>
      <input
        type="date"
        value={form.trial_ends_at}
        onChange={set("trial_ends_at")}
        className={input}
      />
    </div>
    <div>
      <label className={label}>Einddatum abonnement</label>
      <input
        type="date"
        value={form.subscription_ends_at}
        onChange={set("subscription_ends_at")}
        className={input}
      />
    </div>
    <div>
      <label className={label}>Interne notitie</label>
      <input
        value={form.internal_note}
        onChange={set("internal_note")}
        data-testid="admin-detail-note"
        className={input}
      />
    </div>
    <div>
      <label className={label}>Limiet scans / maand</label>
      <input
        type="number"
        min="0"
        value={form.limit_scans}
        onChange={set("limit_scans")}
        placeholder={`standaard ${planLimits?.scans_per_month ?? "onbeperkt"}`}
        data-testid="admin-limit-scans"
        className={input}
      />
    </div>
    <div>
      <label className={label}>Limiet AI-analyses / maand</label>
      <input
        type="number"
        min="0"
        value={form.limit_ai_analyses}
        onChange={set("limit_ai_analyses")}
        placeholder={`standaard ${planLimits?.ai_analyses_per_month ?? "onbeperkt"}`}
        data-testid="admin-limit-ai"
        className={input}
      />
    </div>
    <div>
      <label className={label}>Limiet verversingen / maand</label>
      <input
        type="number"
        min="0"
        value={form.limit_refreshes}
        onChange={set("limit_refreshes")}
        placeholder={`standaard ${planLimits?.refreshes_per_month ?? "onbeperkt"}`}
        data-testid="admin-limit-refreshes"
        className={input}
      />
    </div>
  </div>
);
